<template>
  <router-link v-bind:to="'/route/' + route.id" :class="'routePreview route-' + route.id">
    <div class="routePreviewInner">
      <div class="map-wrapper">
        <div ref="map" class="map" v-bind:id="'map' + route.id"></div>
        <figure class="urs-favourite urs">
          <img src="../assets/urs_bubble.svg" />
          <figcaption>
            <p>Mein Favorit!</p>
          </figcaption>
        </figure>
      </div>
      <section class="routeDetails">
        <div class="title-mode-header">
          <h2>{{ route.title }}</h2>
          <div class="routeModes">
            <figure class="routeMode" v-for="(routeMode, index) in route.routeModes" :key="index">
              <img v-bind:src="`./img/icons/${routeMode.fields.icon}`" :alt="routeMode.fields.title">
            </figure>
          </div>
        </div>
        <article class="routeDetail"><strong>Reisezeit</strong><span>{{ route.duration }}</span></article>
        <article class="routeDetail"><strong>Reisetips</strong><span>{{ route.numberTips }} Tips</span></article>
      </section>
    </div>
  </router-link>
</template>

<script>
import { generateRouteOnMap, mapStyle } from '../js/maps';

export default {
  name: 'RoutePreview',
  props: {
    route: {
      type: Object,
      required: true,
    },
  },
  async mounted() {
    /**
     * Maps
     * Erst ausführen, wenn Vue content ersetzt hat --> wrap in this.$nextTick(function() {}
     */
    this.$nextTick(() => {
      // console.log(this.$refs); // refs statt id -> funktioniert als component
      const mapContainer = this.$refs.map; // instead of document.getElementById('map1')

      const options = {
        zoom: 9,
        center: new google.maps.LatLng(47.0324233, 7.888315),
        disableDefaultUI: true,
        styles: mapStyle,
        draggable: false,
      };
      this.map = new google.maps.Map(mapContainer, options);

      const partRouteArray = this.route.partRoutes;

      if (partRouteArray) {
        generateRouteOnMap(partRouteArray, this.map, this.route);
      }
    });
  },
  watch: {
    route() {
      const partRouteArray = this.route.partRoutes;

      if (partRouteArray) {
        generateRouteOnMap(partRouteArray, this.map, this.route);
      }
    },
  },
};
</script>

<style lang="scss">
.routePreview{
  width: calc(100% / 3);
  padding: 0 20px;
  text-decoration: none !important;
  color: var(--color-black);
  margin-top: 55px;
  transition: all ease .5s;
  transform: translate3d(0, 0px, 0);

  &:hover, &:focus{
    transform: translate3d(0, -5px, 0);
    color: inherit;

    .routePreviewInner{
      box-shadow: 0 15px 30px rgba(102, 105, 138, 0.15);
    }
  }

  &.route-1{
    .title-mode-header{
      h2{
        color: var(--color-jade);
      }
    }
  }

  &.route-2{
    .title-mode-header{
      h2{
        color: var(--color-dark-blue);
      }
    }
  }

  &.route-3{
    .title-mode-header{
      h2{
        color: var(--color-violet);
      }
    }
  }

  .routePreviewInner{
    box-shadow: 0 15px 30px rgba(102, 105, 138, 0.1);
    transition: all ease .3s;
    border-radius: 8px;
    overflow: hidden;
  }

  .title-mode-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 1px solid #bbb;

    h2{
      margin: 0;
    }

    .routeModes{
      display: flex;

      .routeMode{
        width: 25px;

        &:not(:last-child){
          margin-right: 10px;
        }
      }
    }
  }

  .routeDetails{
    background: white;
    padding: 20px 25px;

    .routeDetail{
      display: flex;
      justify-content: space-between;
      font-size: 1rem;
      margin-top:5px;
    }
  }

  .map-wrapper{
    position: relative;

    .map{
      width:100%;
      height: 500px;
    }

    .urs-favourite{
      position: absolute;
      display: none;
      bottom: 15px;
      right: 15px;
      z-index: 1;
      width: 50%;
      animation-name: 'urs-favourite';
      animation-iteration-count: infinite;
      animation-direction: alternate;
      animation-duration:1.5s;
      animation-timing-function: ease-in-out;
      transform-origin: 75% 100%;

      @media screen and (max-width: 1199px){
        width: 63%;
      }

      img{
        display: block;
        width: 100%;
      }

      figcaption{
        position: absolute;
        top: 0;
        width: 53%;
        left: 0;
        bottom: 63%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 27px;
        border-radius: 53%;
        flex-direction: column;
        text-align: center;
        font-size: .85rem;
        font-weight:600;
        line-height:1rem;
        color: var(--color-orange);

        p:not(:last-child){
          margin-bottom:5px;
        }
      }

      @keyframes urs-favourite {
        from {
          transform: rotate(0);
        }

        to {
          transform: rotate(2deg);
        }
      }
    }
  }

  &.route-2{
    .map-wrapper{
      .urs-favourite{
        display: block;
      }
    }
  }
}
</style>
